import { api } from '../../../api/common/instances';

const state = {
  main: {},
  loadingCount: 0,
};

const mutations = {
  setMain(state, data) {
    state.main = data;
  },
  increaseLoadingCount(state) {
    state.loadingCount++;
  },
  resetLoadingCount(state) {
    state.loadingCount = 0;
  },
};

const actions = {
  async fetchMain({ commit }, step) {
    const { data: data } = await api.get('/analysis/dsrviewer/detail/main', {
      params: {
        svrYmdhms: step.svrYmdhms,
        sstmId: step.sstmId,
        instId: step.instId,
        nodeId: step.nodeId,
        transid: step.transid,
        starttimel: step.starttimel,
      },
    });
    commit('setMain', data);
  },
  increaseLoadingCount({ commit }) {
    commit('increaseLoadingCount');
  },
  resetLoadingCount({ commit }) {
    commit('resetLoadingCount');
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
